export const environment = {
    apirul  : '',
};
